import Button from "../ui/Button";
import FullPageLoader from "component/ui/fullPageLoader";

const ConfirmationDialog = ({
  children,
  variant = "primary",
  size = "sm",
  fullWidth = false,
  buttonShow = [],
  className,
  onConfirm,
  isDialogOpen,
  actionButtonName,
  closeDialog,
  cancelButtonName,
  isLoading,
  ...props
}) => {
  return (
    <>
      {isDialogOpen?.open && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50"
          onClick={closeDialog}
        >
          {isLoading && <FullPageLoader/>}
          <div
            className="bg-white p-6 rounded-lg w-96 shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-xl mb-4">{isDialogOpen?.message}</div>
            <div className="flex justify-between gap-4">
              {buttonShow.includes("OK") && (
                <Button
                  style={{ marginLeft: "auto" }}
                  children={"OK"}
                  onClick={closeDialog}
                />
              )}{" "}
              {buttonShow.includes("Cancel") && (
                <Button
                
                  style={{ marginLeft: "auto" }}
                  children={cancelButtonName ? cancelButtonName : "Cancel"}
                  onClick={closeDialog}
                />
              )}{" "}
              {buttonShow.includes("actionButton") && (
                <Button  children={actionButtonName} onClick={onConfirm} />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmationDialog;
